/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { useLocation } from 'react-router-dom';
import { withGrowl } from '../../components/GrowlNotifications';
import { growlErrors } from '../../utils/NotificationUtil';
import { Loading } from '../../components/Loading';

import { withAccount } from '../../components/AccountContext';
import ConsumptionList from './ConsumptionList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../utils/UrlUtil';
import { VIEWER_LOCALE } from '../../components/Query';
import {
  growlShape,
} from '../../components/prop-types';

export const CONSUMPTION_LIST_QUERY = gql`
  query ConsumptionListQuery(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: ConsumptionLogFilter
    $sort: ConsumptionLogSortSpecifier
  ) {
    account(id: $accountId) {
      id
      consumptionLogs(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        totalCount
        indexFrom
        indexTo
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            type
            consumedOn
            consumedCredits
            consumedBy {
              id
              firstName
              lastName
            }
            template {
              ... on ConsumptionAssessmentTemplate {
                title
              }
              ... on ConsumptionSurveyTemplate {
                title
              }
            },
            respondent {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`;

const ConsumptionQuery = ({ currentAccount, growl }) => {
  const location = useLocation();

  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
  };

  return (
    <Query query={VIEWER_LOCALE}>
      {({ data, loading, error }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const locale = data && data.viewer ? data.viewer.locale : 'en-US';

        return (
          <Query query={CONSUMPTION_LIST_QUERY} variables={variables} fetchPolicy="network-only">
            {({ data, loading, error }) => {
              if (error) return `Error! ${error.message}`;

              const connection = data && data.account ? data.account.consumptionLogs : emptyConnection();

              return (
                <ConsumptionList
                  connection={connection}
                  loading={loading}
                  currentAccount={currentAccount}
                  locale={locale}
                />
              );
            }}
          </Query>
        );
      }}
    </Query>
  );
};

ConsumptionQuery.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl((withAccount(ConsumptionQuery)));
